import React from 'react';
import { ScoreTodayCell } from 'components/scores';

const LeaderboardCellToday = ({ data }) => {
    return (
        <div className="leaderboard__cell leaderboard__cell--today">
            <ScoreTodayCell childCss='leaderboard__score-cell' par={data.today} />
        </div>
    );
};

export default LeaderboardCellToday;
